import React, { useEffect, useState } from "react";
import ClientAdvisorButton from "./oveview/ClientAdvisorButton";
//import CustomProgressBar from "./oveview/ProgessBar";
import UnassignedLicensesButton from "./oveview/UasignedButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
//import useCustomStyles from "../hooks/useCustomStyles";
//import { accessCodesStyles } from "../assets/styles/accessCodesStyles";

import {
  getAccessCodes,
  getBusinesses,
  getContractsByBusinesses,
} from "../store/actions/accessCodeActions";
import { useNavigate } from "react-router-dom";
import useCustomStyles from "../hooks/useCustomStyles";
import { accessCodesStyles } from "../assets/styles/accessCodesStyles";
// import { selectState } from "../store/slices/notificationSlice";
import { selectState } from "../store/slices/themeSlice";
import {
  getAdvisorsAction,
  getClientsAction,
  getSubscriberSummary,
  getClientsActivityAction,
} from "../store/actions/clientsActions";
import CustomButton from "../components/CustomButton";
import { fetchBusinesses } from '../store/actions/businessActions'

function dashboard() {
  const { user } = useSelector((state: RootState) => state.auth_slice);

  //const width = window.innerWidth; // Web equivalent for width and height
  const { contracts, accessCodes } = useSelector(
    (state: RootState) => state.accessCode_slice,
  );
  const { clients, advisors, subscribers, error, errorLog, clientsActivity } =
    useSelector((state: RootState) => state.clients_slice);

  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(accessCodesStyles, theme);

  const [clientLicences, setClientLicences] = useState(0);
  const [advisorLicences, setAdvisorLicences] = useState(0);
  const [openLicences, setOpenLicences] = useState({ total: 0, assigned: 0 });
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const isSopherAdmin =
    user?.business?.name === "sopher" || user?.business?.name === "sopher-test";

  const isOlympeAdmin =
    user?.business?.name == "OLYMPE" || user?.business?.name == "OLYMPE_TEST";

  useEffect(() => {
    if (advisors) {
      setAdvisorLicences(advisors.length);
    }
    if (clients) {
      setClientLicences(clients.length);
    }
  }, [advisors, clients]);

  useEffect(() => {
    if (user && user.business) {
      if (user?.business?.name) {
        const isAdmin = user.roles.includes("master");
        let businessNames: string[];

        switch (user.business.name) {
          case "sopher":
            businessNames = isAdmin
              ? ["sopher", "SOPHER_ACCOUNTING"]
              : ["sopher"];
            break;

          case "sopher-test": {
            // console.log('sopher-test business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = isAdmin
              ? ["sopher-test", "SOPHER_ACCOUNTING_TEST"]
              : ["sopher-test"];
            break;
          }

          default: {
            //console.log('default business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = [user.business.name];
            break;
          }
        }

        // console.log('businessNames from get dashboard before  getAccessCodes', businessNames)
        dispatch(
          getAccessCodes({
            business_names: businessNames,
          }),
        );
        dispatch(
          getClientsAction({
            business_names: businessNames,
            token: user.token,
          }),
        );
        user.business?.name == "elisyan" ||
        user.business?.name == "elisyan-test"
          ? dispatch(getAdvisorsAction({ business_names: [] }))
          : dispatch(getAdvisorsAction({ business_names: businessNames }));
        dispatch(getContractsByBusinesses({ business_names: businessNames }));
      }

      dispatch(getBusinesses({ type: '' }))
   
      dispatch(fetchBusinesses({ page: 1, limit: 100 }));
      
      //dispatch(fetchErrorLogs());
    }
    // handleGetContracts();
  }, []);

  useEffect(() => {
    // console.log('clients, dashboard useEffect called!!!', clients)
    if (clients && clients.length > 0) {
      dispatch(
        getSubscriberSummary({
          userIds: clients.map((client) => client.app_user_id),
        }),
      );
      dispatch(
        getClientsActivityAction({
          userIds: clients.map((client) => client.app_user_id),
        }),
      );
    }
  }, [clients]);

  /* useEffect(() => {
    // Update client and advisor licenses from accessCodes regardless of validation
    if (accessCodes) {
      let totalClientLicences = 0;
      let totalAdvisorLicences = 0;

      accessCodes.forEach((accessCode) => {
        if (accessCode.role_type === "client" && accessCode.validated) {
          totalClientLicences += 1;
        } else if (accessCode.role_type === "advisor" && accessCode.validated) {
          totalAdvisorLicences += 1;
        }
      });

      setClientLicences(totalClientLicences);
      setAdvisorLicences(totalAdvisorLicences);
    }
  }, [accessCodes]);*/

  useEffect(() => {
    if (contracts) {
      // Initialize an object to accumulate total and assigned licenses
      const totalLicences = { total: 0, assigned: 0 };

      contracts.forEach((contract) => {
        // Accumulate the total licenses based on useLimit
        totalLicences.total += contract.useLimit;

        // Accumulate the assigned licenses based on licence_count
        totalLicences.assigned += contract.licence_count;

        // Also fold in usage from whitelabel referral codes issued against
        // this contract. Their useLimit is carved out of the contract's own
        // useLimit (already counted above), but their useCount reflects
        // redemptions that aren't otherwise captured in licence_count.
        accessCodes
          ?.filter(
            (code) =>
              code.codeType === "whitelabel-referral-code" &&
              code.contract_ref === contract.id,
          )
          .forEach((code) => {
            totalLicences.assigned += code.useCount || 0;
          });
      });

      // Update the state with the total licenses object
      setOpenLicences(totalLicences);
    }
  }, [contracts, accessCodes]);

  // const getUserRevenueCat = async(userId: string) => {
  //   try{
  //     await dispatch(getSubscriberSummary({userIds: [userId]})).unwrap()
  //     console.log('USER SUBSCRIPTION SUMMARY RC ======>>>', subscribers)
  //   }catch(e){
  //     console.log('USER SUBSCRIPTION SUMMARY RC  error ======>>>', e)
  //   }
  // }

  // useEffect(() => {
  //   console.log(
  //     'USER SUBSCRIPTION SUMMARY RC useEffect error ======>>>',
  //     error,
  //     subscribers,
  //   )
  // }, [error, subscribers])
  useEffect(() => {
    // console.log('ErrorLog AWS', errorLog)
  }, [errorLog]);
  const isElisyan = user?.business?.name === "elisyan";

  return (
    // <div style={{ width: "300px", marginTop: "100px", alignContent: "center" }}>
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}> OVERVIEW</h2>
        <div
          className={classes.buttonContainer}
          style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "flex-start" }}
        >
          {isElisyan && (
            <CustomButton
              title={"invite dispatch ➡"}
              handleClick={() => {
                console.log("Navigate to upload client IDs page");
                navigate("/inviteDispatch");
              }}
              name={"upload-clientIds"}
              loading={false}
            />
          )}
          {isElisyan && (
            <CustomButton
              title={"send invitation ➡"}
              handleClick={() => navigate("/sendInvitation")}
              name={"send-invitation"}
              loading={false}
            />
          )}
        </div>
      </div>
      <div style={{ marginBottom: "40px", maxWidth: "480px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "16px",
            alignItems: "center",
            marginTop: "10px",
            alignContent: "center",
            width: "100%",
          }}
        >
          <ClientAdvisorButton
            number={clientLicences}
            mainText={
              clientLicences > 1 || clientLicences == 0 ? "Clients" : "Client"
            }
            onPress={() => navigate("/clients")}
          />
          {(isSopherAdmin || isOlympeAdmin) && (
            <ClientAdvisorButton
              number={advisorLicences}
              mainText={
                advisorLicences > 1 || advisorLicences == 0
                  ? "Advisors"
                  : "Advisor"
              }
              onPress={() => navigate("/advisors")}
            />
          )}
        </div>
        <UnassignedLicensesButton
          unassignedLicenseNumber={openLicences.total - openLicences.assigned}
          unassignedLicenseLimitNumber={openLicences.total}
          mainText={"Available Licences"}
          onPress={() => navigate("/accessCodes")}
        />
      </div>
      {/* <p style={{ width: "75px", height: "18px", marginLeft: "20px" }}>
        Marketing
      </p>
      <MarketingButton
        unassignedLicenseNumber={0}
        unassignedLicenseLimitNumber={10}
        mainText={"Active Referral Codes"}
        width={width}
      /> */}
    </div>
    // </div>
  );
}

export default dashboard;
